<div *ngIf="registration != undefined"
      (click)="showList = false; $event.stopPropagation();"
      class="listContainer">
      <div *ngIf="showList" (click)="showList = !showList;" class="list-overlay-close"></div>
    <div class="list-title {{ isRequired ? 'field-required' : '' }}">
        <span class="title">
            {{ 'reg.institution' | translate }}
        </span>
    </div>
    <div class="row p-0 m-0 page-table expanded-list">
        <div class="list-group-collapse duo flex-wrap list-item-container">
            <div *ngIf="registrationInstitution?.id" class="{{ disabled ? 'list-item-disabled' : 'list-item' }} duo first item">
                <div class="d-flex justify-content-between col">
                    <div class="d-flex align-items-center w-100" (click)="openEdit(registrationInstitution);$event.stopPropagation();">
                        <span>{{registrationInstitution.name}}</span>
                    </div>
                    <div class="d-flex align-items-center" *ngIf="!disabled">
                        <confirmation [showTrashIcon]="true"
                            [question]="'confirm.areyousure'"
                            [extraClasses]="'d-flex'"
                            (click)="$event.stopPropagation()"
                            (isConfirmed)="deleteRegistrationInstitution($event, registrationInstitution.id)"></confirmation>
                    </div>
                </div>
            </div>
        </div>
        <drawer-items class="mt-1"
            [items]="institutions"
            [title]="'reg.institution'"
            (itemSelected)="addRegistrationInstitution($event)"
            [openListButtonLabel]="'Select or add new'"
            [showAddButton]="true"
            (askForNew)="openEdit(false, $event)"></drawer-items>
    </div>
</div>